// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gDf0","colBig":"styles_colBig__12dNR","colSmall":"styles_colSmall__2g-F9","shopifyNameWrapper":"styles_shopifyNameWrapper__tQ-NA"};